






import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { IWebApplicationMessageCommunicatable, WebApplicationExecutePatterns } from "../../domain/localhost";
import { Patient } from "../../domain/patient";

@Component
export default class WebApplicationAdapter extends Mixins() {
  data() {
    return {
      applicationUrl: null as string,
      isClosing: false,
    };
  }
  applicationUrl: string;
  isClosing: boolean;
  communicator: IWebApplicationMessageCommunicatable;
  
  @Prop()
  requestKey: string;

  @Prop()
  communicatorMessage: string;

  $refs!: {
    applicationFrame: HTMLIFrameElement,
  };

  mounted() {
    window.addEventListener("message", this.onMessageReceived, false);
    this.initializeAdapter();
  }

  destroyed() {
    window.removeEventListener("message", this.onMessageReceived, false);
  }

  private onMessageReceived(event: any): void {
    // 拡張機能からもメッセージを受信することがある
    this.$logger.info("メッセージを受信しました。");
    console.debug(event.data);
    
    if (!this.communicator) { return; }
    this.communicator.analyzeMessage(event.data, null);
  }

  private async initializeAdapter(): Promise<void> {
    try {
      this.communicator = await this.createCommunicator(this.requestKey);
      const info = await this.communicator.getApplicationInformation(this.communicatorMessage);
      if (info.pattern === WebApplicationExecutePatterns.Iframe) {
        this.$logger.debug("iframeでWEBアプリケーションを開きます。" + info.url);
        this.applicationUrl = info.url;
      }
      if (info.pattern === WebApplicationExecutePatterns.Get) {
        this.$logger.debug("ページ遷移でWEBアプリケーションを開きます。" + info.url);
        window.location.href = info.url;
      }
      if (info.pattern === WebApplicationExecutePatterns.AnalyzePostedData) {
        this.$logger.debug("POSTされたデータを解析します。");
        console.debug(info.postedData);
        this.communicator.analyzeMessage(null, info.postedData);
      }
    } catch (e) {
      this.$error("エラー", "外部WEBアプリケーションの呼び出し処理中にエラーが発生しました。", e);
    }
  }

  private async createCommunicator(requestKey: string): Promise<IWebApplicationMessageCommunicatable> {
    const service = DomainRegistry.localhost.getApplicationService();
    const communicator = await service.createWebApplicationMessageCommunicator(requestKey);
    communicator.onError = () => this.closeWindow();
    communicator.onComplete = () => this.closeWindow();
    communicator.postMessage = (message: any) => this.postMessage(message);
    communicator.getPatient = (patientCode: string) => this.getPatient(patientCode);
    await communicator.initialize();
    return communicator;
  }

  private async getPatient(patientCode: string): Promise<Patient> {
    this.$logger.info("患者情報を取得します。");
    const repo = DomainRegistry.patient.getPatientRepository();
    return repo.getEntity(patientCode);
  }

  private async closeWindow(): Promise<void> {
    this.$logger.info("ウィンドウを閉じます。");
    this.isClosing = true;
    const configuration = this.$configuration.behavior.localhost.externalScript.webApplication;
    if (configuration.closeWaitMilliSeconds > 0) {
      await this.$sleep(configuration.closeWaitMilliSeconds);
    }
    this.$closeWindow(true);
  }

  private postMessage(message: any): void {
    this.$logger.info("WEBアプリケーションにメッセージを送信します。");
    console.debug(message);

    if (!this.$refs.applicationFrame) { throw new Error("applicationFrame is empty!!!"); }
    this.$refs.applicationFrame.contentWindow.postMessage(message, "*");
  }
}
